import userRoles from '../const/userRoles'
import userNodeRoles from '../const/userNodeRoles'

const isUserNode = (node) => {
  if (!node)
    return false
  return node.user_node_role_id
}

/**
 *
 * @param userNode
 * @returns {number|*}
 */
export const getUserNodeRole = (userNode) => {
  if (!userNode)
    return userNodeRoles.NONE
  if (!userNode.user_node_role_id)
    return userNodeRoles.NONE
  return userNode.user_node_role_id
}

/**
 *
 * @param store
 * @param user
 * @param node
 * @returns {null|*}
 */
export const determineUserNode = (store, user, node) => {
  if (isUserNode(node)) {
    return node
  }

  const allUserNodes = []
  const ancestorNodes = store.getters['common/node'](node.id, true, true)
  const authNodes = (Array.isArray(ancestorNodes) ? ancestorNodes : node ? [node] : []).filter(x => x?.is_auth)
  authNodes.forEach(an => {
    const user_nodes = user.user_nodes.filter(x => x.node_id === an.id)
    Array.prototype.push.apply(allUserNodes, user_nodes);
  })
  if (allUserNodes.length === 0) {
    return null
  } else {
    return allUserNodes[0]
  }
}

/**
 * システム管理者か否か
 * @param user
 * @param organization
 * @returns {*|boolean}
 */
export const canSystemAdmin = (user, organization) => {
  const user_role = user.user_role
  return organization.admin && (user_role.code === userRoles.SUPER_ADMIN || user_role.code === userRoles.ADMIN)
}

/**
 * 設計者以上か否か
 * @param user
 * @param organization
 * @returns {*|boolean}
 */
export const canArchitect = (user, organization) => {
  if (canSystemAdmin(user, organization))
    return true
  const user_role = user.user_role
  return organization.admin && user_role.code === userRoles.ARCHITECT
}

/**
 * ユーザが対象ノードにアクセス可能かどうかを判定する。
 */
export const canAccessNode = (store, nodeId, user) => {
  if (canSystemAdmin(user, user.organization))
    return true
  const nodes = store.getters['common/node'](nodeId, true, true)
  // 無い場合は不可
  if (nodes === null)
    return false
  if (!Array.isArray(nodes) || nodes.length === 0)
    return false
  // ルートまで遡る
  const rootNode = nodes[0]
  // ユーザーノードを検索
  const userNode = user.user_nodes.find(x => x.node_id === rootNode.id)
  if (!userNode)
    return false
  return [userNodeRoles.MONITOR, userNodeRoles.CONFIGURE, userNodeRoles.OPERATE].indexOf(userNode.user_node_role_id) !== -1
}

/**
 * ユーザが対象データセットにアクセス可能かどうかを判定する。
 * @param store
 * @param datasetId
 * @param user
 * @returns {boolean}
 */
export const canAccessDataset = (store, datasetId, user) => {
  if (canSystemAdmin(user, user.organization))
    return true
  const nodesTree = store.getters['common/nodesTree']
  const res = nodesTree.all(x => {
    const dataset_id_list = x.model.dataset_id_list
    if (dataset_id_list === null || dataset_id_list === undefined)
      return false
    return dataset_id_list.indexOf(datasetId) !== -1
  }).filter(x => canAccessNode(store, x.model.id, user))
  return res.length > 0
}

/**
 *
 * @param store
 * @param user
 * @param node
 */
export const authorizeNodeRead = (store, user, node) => {
  if (canSystemAdmin(user, user.organization))
    return true
  if (!node)
    return false
  const userNode = isUserNode(node) ? node : determineUserNode(store, user, node)
  if (!userNode)
    return false
  const role = userNode.user_node_role_id
  return role !== userNodeRoles.NONE
}

/**
 *
 * @param user
 * @param userNode
 * @returns {boolean}
 */
const authorizeRead = (user, userNode) => {
  if (canSystemAdmin(user, user.organization))
    return true
  const role = getUserNodeRole(userNode)
  return role !== userNodeRoles.NONE;
}

/**
 *
 * @param user
 * @param userNode
 * @returns {boolean}
 */
const authorizeNodeA = (user, userNode) => {
  if (canSystemAdmin(user, user.organization))
    return true
  const role = getUserNodeRole(userNode)
  return [userNodeRoles.MONITOR, userNodeRoles.CONFIGURE, userNodeRoles.OPERATE].indexOf(role) !== -1;
}

/**
 *
 * @param user
 * @param userNode
 * @returns {boolean}
 */
const authorizeNodeB = (user, userNode) => {
  if (canSystemAdmin(user, user.organization))
    return true
  const role = getUserNodeRole(userNode)
  return [userNodeRoles.CONFIGURE, userNodeRoles.OPERATE].indexOf(role) !== -1;
}

/**
 *
 * @param user
 * @param userNode
 * @returns {boolean}
 */
const authorizeNodeC = (user, userNode) => {
  if (canSystemAdmin(user, user.organization))
    return true
  const role = getUserNodeRole(userNode)
  return [userNodeRoles.OPERATE].indexOf(role) !== -1;
}

/**
 *
 * @param user
 * @param userNode
 * @returns {boolean}
 */
const authorizeNodeD = (user, userNode) => {
  if (canSystemAdmin(user, user.organization))
    return true
  const role = getUserNodeRole(userNode)
  return !!(canArchitect(user, user.organization) && [userNodeRoles.MONITOR, userNodeRoles.CONFIGURE, userNodeRoles.OPERATE].indexOf(role) !== -1);
}

/**
 *
 * @param store
 * @param user
 * @param node
 */
export const handleWriteA = (store, user, node) => {
  const userNode = determineUserNode(store, user, node)
  return authorizeNodeA(user, userNode)
}

/**
 *
 * @param store
 * @param user
 * @param node
 */
export const handleReadA = (store, user, node) => {
  const userNode = determineUserNode(store, user, node)
  return authorizeRead(user, userNode)
}

/**
 *
 * @param store
 * @param user
 * @param node
 */
export const handleWriteB = (store, user, node) => {
  const userNode = determineUserNode(store, user, node)
  return authorizeNodeB(user, userNode)
}

/**
 *
 * @param store
 * @param user
 * @param node
 */
export const handleReadB = (store, user, node) => {
  const userNode = determineUserNode(store, user, node)
  return authorizeRead(user, userNode)
}

/**
 *
 * @param store
 * @param user
 * @param node
 */
export const handleWriteC = (store, user, node) => {
  const userNode = determineUserNode(store, user, node)
  return authorizeNodeC(user, userNode)
}

/**
 *
 * @param store
 * @param user
 * @param node
 */
export const handleReadC = (store, user, node) => {
  const userNode = determineUserNode(store, user, node)
  return authorizeRead(user, userNode)
}

/**
 *
 * @param store
 * @param user
 * @param node
 */
export const handleWriteD = (store, user, node) => {
  const userNode = determineUserNode(store, user, node)
  return authorizeNodeD(user, userNode)
}

/**
 *
 * @param store
 * @param user
 * @param node
 */
export const handleReadD = (store, user, node) => {
  const userNode = determineUserNode(store, user, node)
  return authorizeNodeD(user, userNode)
}

/**
 *
 * @param store
 * @param user
 * @param node
 */
export const handleReadDataset = (store, user, node) => {
  const userNode = determineUserNode(store, user, node)
  return authorizeNodeRead(user, userNode)
}
